export default (date: any) => {
    const months = [
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря",
    ];
    date = date.split('-');
    const timeAndDay = date[2].split('T')
    return timeAndDay[0] + " " + months[date[1] - 1] + " " + date[0];
};
